import {type FUNDING_SOURCE, type PayPalButtonsComponentOptions} from '@paypal/paypal-js';
import {FeatureFlag} from '../../../@type/features';
import {Feature} from '../features';
import {AbstractPayPalPayment} from './abstract/class-abstract-paypal-payment';

class PayPalCreditPayment extends AbstractPayPalPayment {
	public gatewayId() {
		return 'peachpay_paypal_credit';
	}

	protected fundingType(): FUNDING_SOURCE {
		return 'credit';
	}

	protected buttonStyle() {
		return Feature.metadata<PayPalButtonsComponentOptions['style']>(FeatureFlag.PAYPAL_CREDIT_GATEWAY, 'button_style') ?? undefined;
	}
}

export {PayPalCreditPayment};
